import { Link, useLocation } from "wouter";
import { LayoutDashboard } from "lucide-react";
import { useAuth } from "@/hooks/useAuth";

// Floating admin button — only visible to admins, hides while already on
// any /admin route. Pairs with FeedbackWidget (sits above it via bottom
// offset). Plain anchor (not shadcn Button) so the disabled-pointer-events
// trap can never apply.
export function AdminQuickAccess() {
  const { isAdmin } = useAuth();
  const [pathname] = useLocation();
  if (!isAdmin) return null;
  if (pathname.startsWith("/admin")) return null;

  return (
    <Link
      href="/admin"
      className="fixed right-4 z-40 inline-flex items-center gap-2 rounded-full bg-foreground px-4 py-2.5 text-sm font-semibold text-background shadow-lg shadow-foreground/20 hover:bg-foreground/90"
      style={{ bottom: "calc(env(safe-area-inset-bottom, 0px) + 116px)" }}
      data-testid="admin-quick-access"
      aria-label="Open admin dashboard"
    >
      <LayoutDashboard className="h-4 w-4" />
      Admin
    </Link>
  );
}
